module.exports = __webpack_public_path__ + "img/pp-22.471152db.jpg";